import { render, staticRenderFns } from "./KasKecil.vue?vue&type=template&id=6f9806d6"
import script from "./KasKecil.vue?vue&type=script&lang=js"
export * from "./KasKecil.vue?vue&type=script&lang=js"
import style0 from "./KasKecil.vue?vue&type=style&index=0&id=6f9806d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports